module.exports = __webpack_public_path__ + "assets/img/chirp-home-active.2d77a5df.svg";